(function(){
    'use strict'

    angular
    .module('app.empleados')
    .controller('EditarEmpleado', EditarEmpleado);

    EditarEmpleado.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','EmpleadosService', 'BancosService', 'NacionalidadesService', 'TiposPlanillaService', 'PuestosService', 'DepartamentosService', 'TurnosService', 'HorariosService', 'AreasService', 'ArchivoCCSSService', 'CuentasContablesService', 'PerfilesAsientoService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditarEmpleado($q, $scope, $animationsSrv, $routeParams, EmpleadosService, BancosService, NacionalidadesService, TiposPlanillaService, PuestosService, DepartamentosService, TurnosService, HorariosService, AreasService, ArchivoCCSSService, CuentasContablesService, PerfilesAsientoService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.puestos = [];
        vm.departamentos = [];
        vm.tiposPlanilla = [];
        vm.nacionalidades = [];
        vm.turnos = [];
        vm.horarios = [];
        vm.areas = [];
        vm.bancos = [];
        vm.tiposSeguro = [];
        vm.cuentas = [];
        vm.perfilesAsiento = [];

        vm.empleado = {
            activo: true,
            esOrdinario: true,
            rebajoAlimentacion: true,
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nacionalidadId: -1,
            turnoId: -1,
            bancoId: -1,
            sexo: 'indefinido',
            estadoCivil: 'indefinido',
            tipoSeguro: 'indefinido',
            montoBonificacion: 0,
            montoAhorroEscolar: 0,
            montoAhorroAsociacion: 0,
            montoSalarioPromedio: 0,
            diasLaborados: 0,
            saldoAcumuladoVacaciones: 0,
            vacacionesPorAnno: 12,
            horarioId: -1,
            areaId: -1,
            cuentaMayor: -1,
            perfilAsientoId: -1,
            montoEmbargoSalario: 0,
            montoEmbargoSalario2: 0,
            montoPensionAlimentaria: 0,
            escolaridadId: -1,
            tieneLicencia: false,
        };

        $scope.imageSrc = null;

        vm.empleadoId = $routeParams.id ? $routeParams.id : 0;

        /** Date Picker Functions */
        vm.fechaNacimientoOptions = {
            showWeeks: true
        };

        vm.openFechaNacimiento = function(){
            vm.fechaNacimientoOpened = !vm.fechaNacimientoOpened;
        };

        vm.fechaIngresoOptions = {
            showWeeks: true
        };

        vm.openFechaIngreso = function(){
            vm.fechaIngresoOpened = !vm.fechaIngresoOpened;
        };

        vm.fechaSalidaOptions = {
            showWeeks: true
        };

        vm.openFechaSalida = function(){
            vm.fechaSalidaOpened = !vm.fechaSalidaOpened;
        };

        vm.fechaUltimoAumentoOptions = {
            showWeeks: true
        };

        vm.openFechaUltimoAumento = function(){
            vm.fechaUltimoAumentoOpened = !vm.fechaUltimoAumentoOpened;
        };
        /** End Date Picker Functions */

        function validateTipoSeguro(){
            if(!vm.empleado.tipoSeguro || vm.empleado.tipoSeguro == 'indefinido'){
                $scope.empleadoForm.tipoSeguro.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.tipoSeguro.$setValidity("different", true);
            }
        };
        
        vm.tipoSeguroChange = function(){
            validateTipoSeguro();
        };

        function validateSexo(){
            if(!vm.empleado.sexo || vm.empleado.sexo == 'indefinido'){
                $scope.empleadoForm.sexo.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.sexo.$setValidity("different", true);
            }
        };
        
        vm.sexoChange = function(){
            validateSexo();
        };

        function validateEstadoCivil(){
            if(!vm.empleado.estadoCivil || vm.empleado.estadoCivil == 'indefinido'){
                $scope.empleadoForm.estadoCivil.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.estadoCivil.$setValidity("different", true);
            }
        };

        vm.estadoCivilChange = function(){
            validateEstadoCivil();
        };

        function validateTurno(){
            if(vm.empleado.turnoId == -1){
                $scope.empleadoForm.turnoId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.turnoId.$setValidity("different", true);
            }
        };

        vm.turnosChange = function(){
            validateTurno();
        };

        function validateTipoPlanilla(){
            if(vm.empleado.tipoPlanillaId == -1){
                $scope.empleadoForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        vm.tiposPlanillaChange = function(){
            validateTipoPlanilla();
        };

        function validatePuesto(){
            if(vm.empleado.puestoId == -1){
                $scope.empleadoForm.puestoId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.puestoId.$setValidity("different", true);
            }
        };

        vm.puestosChange = function(){
            validatePuesto();
        };

        function validateDepartamento(){
            if(vm.empleado.departamentoId == -1){
                $scope.empleadoForm.departamentoId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.departamentoId.$setValidity("different", true);
            }
        };

        vm.departamentosChange = function(){
            validateDepartamento();
        };

        function validateNacionalidad(){
            if(vm.empleado.nacionalidadId == -1){
                $scope.empleadoForm.nacionalidadId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.nacionalidadId.$setValidity("different", true);
            }
        };

        vm.nacionalidadesChange = function(){
            validateNacionalidad();
        };

        function validateBanco(){
            if(vm.empleado.bancoId == -1){
                $scope.empleadoForm.bancoId.$setValidity("different", false);
            }
            else{
                $scope.empleadoForm.bancoId.$setValidity("different", true);
            }
        };

        vm.bancosChange = function(){
            validateBanco();
        };

        var promiseTipoSeguro = getTipoSeguro();
        var promisePuesto = getPuesto();
        var promiseDepartamento = getDepartamento();
        var promiseTiposPlanilla = getTiposPlanilla();
        var promiseNacionalidades = getNacionalidades();
        var promiseTurnos = getTurnos();
        var promiseHorarios = getHorarios();
        var promiseAreas = getAreas();
        var promiseBancos = getBancos();
        var promiseCuentas = getCuentas();
        var promisePerfilesAsiento = getPerfilesAsiento();

        getEmpleado();

        function getTipoSeguro(){
            var promise = ArchivoCCSSService.getTiposSeguro()
            .then(function(tiposSeguro){
                vm.tiposSeguro = tiposSeguro;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de seguro.');
            }); 
            
            return promise;
        };

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAll(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getNacionalidades(){
            var promise = NacionalidadesService.getAll()
            .then(function(nacionalidades){
                vm.nacionalidades = nacionalidades;
            })
            .catch(function(error){
                $logger.error('Error al obtener las nacionalidades.');
            }); 
            
            return promise;
        };

        function getTurnos(){
            var promise = TurnosService.getAll()
            .then(function(turnos){
                vm.turnos = turnos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los turnos.');
            }); 
            
            return promise;
        };

        function getHorarios(){
            var promise = HorariosService.getAll()
            .then(function(horarios){
                vm.horarios = horarios;
            })
            .catch(function(error){
                $logger.error('Error al obtener los horarios.');
            }); 
            
            return promise;
        };

        function getAreas(){
            var promise = AreasService.getAll(UserInfoService.getCompaniaId())
            .then(function(areas){
                vm.areas = areas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las areas.');
            }); 
            
            return promise;
        };

        function getBancos(){
            var promise = BancosService.getAll()
            .then(function(bancos){
                vm.bancos = bancos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los bancos.')
            }); 
            
            return promise;
        };

        function getCuentas(){
            var promise = CuentasContablesService.getAll(UserInfoService.getCompaniaId())
            .then(function(cuentas){
                vm.cuentas = cuentas;
            })
            .catch(function(error){
                $logger.error('Error al obtener las cuentas contables.')
            }); 
            
            return promise;
        };

        function getPerfilesAsiento(){
            var promise = PerfilesAsientoService.getAllPerfil()
            .then(function(perfiles){
                vm.perfilesAsiento = perfiles;
            })
            .catch(function(error){
                $logger.error('Error al obtener los perfiles de asiento.')
            }); 
            
            return promise;
        };

        function getEmpleado(){

            $q.all([promiseDepartamento, promisePuesto, promiseTiposPlanilla, promiseNacionalidades, 
                promiseBancos, promiseTurnos, promiseHorarios, promiseAreas, 
                promiseTipoSeguro, promiseCuentas, promisePerfilesAsiento]).then(function(){
                if(vm.empleadoId != 0){
                    var promise = EmpleadosService.getById(UserInfoService.getCompaniaId(), vm.empleadoId);

                    promise
                    .then(function(empleado){
                        empleado.fechaIngreso = moment(empleado.fechaIngreso).toDate();
                        empleado.fechaNacimiento = moment(empleado.fechaNacimiento).toDate();
                        empleado.fechaSalida =  empleado.fechaSalida != null ? moment(empleado.fechaSalida).toDate() : null;
                        empleado.fechaUltimoAumento =  empleado.fechaUltimoAumento != null ? moment(empleado.fechaUltimoAumento).toDate() : null;
                        empleado.activo = empleado.activo == 'S' ? true : false;
                        empleado.esposa = empleado.esposa == 1 ? true : false;
                        empleado.esPensionado = empleado.esPensionado == 1 ? true : false;
                        empleado.embargoSalario = empleado.embargoSalario == 1 ? true : false;
                        empleado.horarioId = empleado.horarioId == null ? -1 : empleado.horarioId; 
                        empleado.areaId = empleado.areaId == null ? -1 : empleado.areaId; 
                        empleado.cuentaMayor = empleado.cuentaMayor == null ? -1 : empleado.cuentaMayor;
                        empleado.perfilAsientoId = empleado.perfilAsientoId == null ? -1 : empleado.perfilAsientoId;
                        empleado.escolaridadId = empleado.escolaridadId == null ? -1 : empleado.escolaridadId;
                        vm.empleado = empleado;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el empleado: ' + error.data.Message);
                                break;
                        }
                    });               
                }                
            });
        };

        function isSalarioDefinedMoreThanOnce(){
            var salarioCounter = 0;
            if(vm.empleado.salarioMensual > 0) salarioCounter++;
            if(vm.empleado.salarioQuincenal > 0) salarioCounter++;
            if(vm.empleado.salarioSemanal > 0) salarioCounter++;
            if(vm.empleado.salarioDiario > 0) salarioCounter++;
            if(vm.empleado.salarioXHora > 0) salarioCounter++;

            return salarioCounter > 1 ? true : false;
        };

        function resetSalarioValidations(){
            $scope.empleadoForm.salarioMensual.$setValidity("morethanone", true);
            $scope.empleadoForm.salarioQuincenal.$setValidity("morethanone", true);
            $scope.empleadoForm.salarioSemanal.$setValidity("morethanone", true);
            $scope.empleadoForm.salarioDiario.$setValidity("morethanone", true);
            $scope.empleadoForm.salarioXHora.$setValidity("morethanone", true);
        };

        function setSalarioValidations(){

            if(vm.empleado.salarioMensual > 0) $scope.empleadoForm.salarioMensual.$setValidity("morethanone", false);
            if(vm.empleado.salarioQuincenal > 0) $scope.empleadoForm.salarioQuincenal.$setValidity("morethanone", false);
            if(vm.empleado.salarioSemanal > 0) $scope.empleadoForm.salarioSemanal.$setValidity("morethanone", false);
            if(vm.empleado.salarioDiario > 0) $scope.empleadoForm.salarioDiario.$setValidity("morethanone", false);
            if(vm.empleado.salarioXHora > 0) $scope.empleadoForm.salarioXHora.$setValidity("morethanone", false);
        };

        function doFormValidations(){
            validateTipoSeguro();
            validateSexo();
            validateEstadoCivil();
            validateTurno();
            validateTipoPlanilla();
            validatePuesto();
            validateDepartamento();
            validateNacionalidad();
            validateBanco();
            resetSalarioValidations();
            if(isSalarioDefinedMoreThanOnce()){
                setSalarioValidations();
            }
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.empleadoForm.$valid){
                if(!vm.empleado.id){
                    saveImage(true);
                }
                else if($scope.empleadoForm.$dirty || document.getElementById("file").files[0]){
                    saveImage(false);
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveImage(isSaving) {
            var currentFile = document.getElementById("file").files[0];

            if(currentFile){
                var r = new FileReader();

                r.onloadend = function(e){
                    var arr = Array.from(new Uint8Array(e.target.result));
                    if(isSaving){
                        saveEmpleado(arr);
                    }else{
                        updateEmpleado(arr);
                    }
                }
                r.readAsArrayBuffer(currentFile);                  
            }
            else{
                if(isSaving){
                    saveEmpleado(null);
                }
                else{
                    updateEmpleado(null);
                }
            }

        }
        function saveEmpleado(imageBytes){
            vm.empleado.image = imageBytes;
            vm.empleado.activo = vm.empleado.activo ? 'S' : 'N';
            vm.empleado.esposa = vm.empleado.esposa ? 1 : 0;
            vm.empleado.esPensionado = vm.empleado.esPensionado ? 1 : 0;
            vm.empleado.embargoSalario = vm.empleado.embargoSalario ? 1 : 0;
            var promise = EmpleadosService.save(vm.empleado);
        
            promise
            .then(function(response){
                logger.success('Empleado creado con éxito.');
                clearEmpleadoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el empleado: ' + error.data.Message);
                        break;
                }
            }); 
        };

        function updateEmpleado(imageBytes){
            vm.empleado.image = imageBytes;
            vm.empleado.activo = vm.empleado.activo ? 'S' : 'N';
            vm.empleado.esposa = vm.empleado.esposa ? 1 : 0;
            vm.empleado.esPensionado = vm.empleado.esPensionado ? 1 : 0;
            vm.empleado.embargoSalario = vm.empleado.embargoSalario ? 1 : 0;
            var promise = EmpleadosService.update(vm.empleado);
            
            promise
            .then(function(response){
                logger.success('Empleado modificado con éxito.');
                $location.path('/empleados');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el empleado: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearEmpleadoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.empleado = {
                activo: true,
                esOrdinario: true,
                rebajoAlimentacion: true,
                puestoId: -1,
                departamentoId: -1,
                tipoPlanillaId: -1,
                nacionalidadId: -1,
                bancoId: -1,
                montoAhorroAsociacion: 0,
                montoAhorroEscolar: 0,
                montoBonificacion: 0,
                montoSalarioPromedio: 0,
                diasLaborados: 0,
                saldoAcumuladoVacaciones: 0,
                vacacionesPorAnno: 12,
                horarioId: -1,
                areaId: -1,
                cuentaMayor: -1,
                perfilAsientoId: -1,
                montoEmbargoSalario: 0,
                montoEmbargoSalario2: 0,
                montoPensionAlimentaria: 0,
                escolaridadId: -1,
                tieneLicencia: false,
            };
            $scope.imageSrc = null;
            // Set back to pristine.
            $scope.empleadoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.empleadoForm.$setUntouched();
        };

    }
})();